export const languageMixin = {
    methods: {
        getDefaultLanguage: function() {
            let language = localStorage.getItem("language") ?? navigator.language.split('-')[0]
            switch (language) {
                case 'en':
                    return 'en'
                case 'fi':
                    return 'fi'
            }
            return 'en'
        }
    }
}